import React from 'react';
import { Settings, PiggyBank, TrendingUp } from 'lucide-react';

/**
 * Секция формы с дополнительными опциями
 */
const AdditionalOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Settings className="w-5 h-5 mr-2 text-gray-500 dark:text-gray-400" />
        Дополнительные опции
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Добровольные взносы на пенсионное страхование */}
        <div className="col-span-full">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="includeInsurance"
              name="includeInsurance"
              checked={formData.includeInsurance}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="includeInsurance" className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <PiggyBank className="w-4 h-4 mr-1 text-blue-500" />
              Учитывать добровольные взносы на пенсионное страхование
            </label>
          </div>
        </div>

        {formData.includeInsurance && (
          <div className="col-span-full ml-6">
            <label htmlFor="insuranceAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Сумма страховых взносов
            </label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                id="insuranceAmount"
                name="insuranceAmount"
                value={formData.insuranceAmount}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.insuranceAmount ? 'input-error' : ''}`}
                placeholder="Введите сумму взносов"
              />
              <button
                type="button"
                onClick={() => {
                  handleInputChange({
                    target: {
                      name: 'insuranceAmount',
                      value: '45842'
                    }
                  });
                }}
                className="px-2 py-1 text-xs bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-900 dark:text-blue-300 dark:hover:bg-blue-800 rounded-md whitespace-nowrap"
              >
                Вставить минимум
              </button>
            </div>
            {errors.insuranceAmount && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.insuranceAmount}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Минимальный размер добровольных взносов в 2023 году: 45 842 ₽
            </p>
          </div>
        )}

        {/* Прочие доходы (НДФЛ) */}
        <div className="col-span-full">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="hasOtherIncome"
              name="hasOtherIncome"
              checked={formData.hasOtherIncome}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="hasOtherIncome" className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <TrendingUp className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" />
              Учитывать доходы по НДФЛ (13%)
            </label>
          </div>
        </div>

        {formData.hasOtherIncome && (
          <div className="col-span-full ml-6">
            <label htmlFor="otherIncome" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Сумма дохода по НДФЛ
            </label>
            <input
              type="text"
              id="otherIncome"
              name="otherIncome"
              value={formData.otherIncome}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.otherIncome ? 'input-error' : ''}`}
              placeholder="Введите сумму дохода"
            />
            {errors.otherIncome && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.otherIncome}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Например, зарплата по трудовому договору, доходы от аренды и др.
            </p>
          </div>
        )}

        {/* Учет инфляции в прогнозах */}
        <div className="col-span-full">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="adjustForInflation"
              name="adjustForInflation"
              checked={formData.adjustForInflation}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <label htmlFor="adjustForInflation" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать инфляцию в прогнозах (7.5% годовых)
            </label>
          </div>
        </div>
      </div>

      {/* Информация о добровольных взносах */}
      {formData.taxSystem === 'npd' && (
        <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-md border border-blue-100 dark:border-blue-800 text-sm">
          <div className="text-blue-700 dark:text-blue-300 font-medium mb-1">Важно о пенсионном страховании:</div>
          <p className="text-blue-600 dark:text-blue-400 text-xs">
            Самозанятые не делают обязательных пенсионных отчислений. Это значит, что период работы на НПД не засчитывается в страховой стаж, 
            а пенсионные права не формируются. Для формирования пенсии рекомендуется делать добровольные взносы.
          </p>
        </div>
      )}
    </div>
  );
};

export default AdditionalOptionsSection;